import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "lc_cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Show after slight delay so it doesn't compete with page load
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const save = (value) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ value, at: new Date().toISOString() })
    );
    setVisible(false);
    // Trigger any analytics enable/disable here if applicable in the future
    if (typeof window !== "undefined" && window.posthog) {
      if (value === "accepted") {
        try { window.posthog.opt_in_capturing(); } catch (e) { /* analytics opt-in not available */ }
      } else {
        try { window.posthog.opt_out_capturing(); } catch (e) { /* analytics opt-out not available */ }
      }
    }
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      className="fixed left-4 right-4 bottom-4 md:left-6 md:bottom-6 md:right-auto md:max-w-md z-[60] bg-ink text-bg shadow-2xl shadow-black/30 animate-fade-up"
    >
      <div className="relative px-6 py-6 md:px-7 md:py-7">
        <button
          data-testid="cookie-banner-close"
          onClick={() => save("rejected")}
          aria-label="Cerrar"
          className="absolute top-3 right-3 text-bone/60 hover:text-bg transition-colors"
        >
          <X className="w-4 h-4" strokeWidth={1.5} />
        </button>
        <div className="text-[10px] uppercase tracking-[0.3em] text-caramel mb-3 font-medium">
          Cookies
        </div>
        <h3 className="font-serif text-2xl md:text-3xl font-light tracking-tight leading-tight mb-3">
          Tu privacidad es importante.
        </h3>
        <p className="text-sm text-bone/85 font-light leading-relaxed mb-6">
          Usamos cookies propias y de terceros para analizar el uso de la web y
          mejorar tu experiencia. Puedes aceptarlas, rechazarlas o consultar más
          información en nuestra{" "}
          <Link
            to="/politica-cookies"
            className="text-caramel hover:text-bg underline-offset-2 underline"
          >
            Política de Cookies
          </Link>.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            data-testid="cookie-accept"
            onClick={() => save("accepted")}
            className="flex-1 bg-bg text-ink px-5 py-3 text-[10px] uppercase tracking-[0.2em] font-medium hover:bg-caramel hover:text-bg transition-colors"
          >
            Aceptar todas
          </button>
          <button
            data-testid="cookie-reject"
            onClick={() => save("rejected")}
            className="flex-1 bg-transparent text-bg border border-bg/60 px-5 py-3 text-[10px] uppercase tracking-[0.2em] font-medium hover:bg-bg hover:text-ink transition-colors"
          >
            Rechazar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
